<template>
	<span @click="clicked" :style="settings.styles" :class="[{ 'active': isActive, 'disabled': isDisabled }, 'nk-toggler', settings.class]" :tabindex="tabindex">
		<div v-if="settings.checkEnabled" :class="[{ 'w-0': !isActive }, 'overflow-hidden', 'toggler-icon']">
			<icon icon="check" class="ml-1" />
		</div>
		<label>{{ settings.display(localData) }}</label>
	</span>
</template>

<script>
	import Get from 'lodash/get'
	import Merge from 'lodash/merge'
	import { isEmpty } from '~/statics/validators'
	import _ from 'lodash'

	export default {
		name: 'toggler',
		emits: ['update:modelValue', 'click'],
		props: {
			options: { type: Object },
			modelValue: {},
			data: { required: true },
			tabindex: { type: [Number, String] },
			startup: { type: Boolean, default: false },
			disabled: { type: Boolean, default: false },
		},
		data() {
			return {
				localData: {},
				settings: {
					identifier: 'id',
					checkEnabled: true,
					selected: false,
					disabled: false,
					display: () => 'Toggler',
					class: '',
				}
			}
		},
		watch: {
			options: {
				deep: true,
				immediate: true,
				handler(val) {
					this.settings = Merge(this.settings, val)
				}
			},
			data: {
				deep: true,
				immediate: true,
				handler(val) {
					this.localData = this.prepareData(val)
				}
			},
		},
		computed: {
			isActive() {
				return this.modelValue === true || this.settings.selected || this.localData.selected || this.identifier(this.modelValue) === this.identifier(this.localData)
			},
			isDisabled() {
				return this.disabled || this.settings.disabled
			},
		},
		methods: {
			prepareData(val) {

				const id = isEmpty(this.modelValue?.id) ? this.idGenerator(5) : this.modelValue.id

				return Merge(
					{
						id: id
					},
					val
				)
			},
			identifier(item) {
				let id

				if (this.settings.identifier) {
					if (_.isFunction(this.settings.identifier))
						id = this.settings.identifier(item)
					else
						id = this.settings.identifier

					return Get(item, id)
				}

				return null
			},
			clicked() {

				if (this.isDisabled)
					return

				this.localData.selected = !this.isActive
				const result = this.localData.selected ? this.localData : null
				this.$emit('click', result, this.localData.selected)
				this.$emit('update:modelValue', result)
			},
			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: `select-deselect`,
					keyCode: 32, // 32:Space
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						e.preventDefault()
						this.clicked()
					},
				})
			},
		},
	}
</script>

<style lang="less">
	@import "~/styles/toggler.less";
</style>